export const deserializeResponse = (rawResponse) => {
  // Some of the arrays are optional, so ensure at least empty arrays are there
  const cleanResponse = { ...rawResponse }
  cleanResponse.inboundItineraries = rawResponse.inboundItineraries || []
  cleanResponse.fares = rawResponse.fares || []
  cleanResponse.bookingData = rawResponse.bookingData || []
  cleanResponse.layovers = rawResponse.layovers || []
  cleanResponse.detailsLinks = rawResponse.detailsLinks || []

  cleanResponse.legs = rawResponse.legs.map(cleanUpLayovers)
  cleanResponse.outboundItineraries = cleanResponse.outboundItineraries.map(cleanUpLayovers)
  cleanResponse.inboundItineraries = cleanResponse.inboundItineraries.map(cleanUpLayovers)

  cleanResponse.fares = cleanResponse.fares.map(fare => {
    // Convert fare prices from strings to numbers
    fare.price = Number(fare.price)
    // Keep original prices around so if we update the prices, the original ones can still be seen
    fare.originalPrice = Number(fare.price)
    return fare
  })

  return cleanResponse
}

const cleanUpLayovers = (obj) => {
  obj.layovers = obj.layovers || []
  return obj
}
